<template>
	<div>
        <div class="row">
            <div class="col-md-12 p-0">
                <iframe src="https://lookerstudio.google.com/embed/reporting/e6074eac-3d8f-479d-bde0-64676c3d3e34/page/p_nsjqs38rwc" frameborder="0" style="border:0;width:100%; calc(100vh - 148px);min-height:calc(100vh - 80px);box-sizing: border-box;" allowfullscreen></iframe>
            </div>
        </div>
   
    </div>
</template>

<script>

export default
{
	//extends: HSSE,
	components: { 
		//ReportParamSelect,
	},

	data() {
		return {

        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
    },
    methods: {

    },
}
</script>

<style scoped>
.corner-wrapper {
  display: block;
  overflow: hidden;
  border-radius: 10px;
  transform: translateZ(0px);
  border: 30px solid #eee;
}
</style>